import React from 'react'
import GroupChatContainer from '../../../../Components/Applications/Chat/GroupChat'

export default function GroupChat() {
  return (
    <div className='page-body'>
        <GroupChatContainer/>
    </div>
  )
}
